import React from "react";
import {
  NewBox as Box,
  NewDivider as Divider,
  NewTypography as Typography,
} from "@bca/ui-library";
import styled from "styled-components";

import { SavedSearchesResponseProps, SavedSearchProps } from "../types";
import NonModalWithState from "../NonModalWithState/NonModalWithState";
import { formatDate } from "../utils/formatDate";
import SavedSearchesSwitch from "../SavedSearchesSwitch/SavedSearchesSwitch";
import { getSavedSearchQueryParams } from "../utils/getSavedSearchQueryParams";

const EllipsisText = styled(Typography)`
  overflow: ellipsis;
`;

const handleBoxClick = (url: string) => {
  window.location.href = `/search${getSavedSearchQueryParams(url)}`;
};

const SavedSearchesMobileView: React.FC<{
  savedData: SavedSearchesResponseProps;
  isToUseAuthZero: boolean;
}> = ({ savedData, isToUseAuthZero }) => (
  <Box aria-label="Saved searches results">
    {savedData?.savedSearches?.map((data: SavedSearchProps) => (
      <Box
        key={data.createdOn}
        border="sm solid fg_light_2"
        borderRadius="sm"
        height="auto"
        marginTop="md"
      >
        <Box
          paddingTop="lg"
          paddingLeft="md"
          paddingRight="md"
          data-testid="mobile-table-box"
          onClick={() => handleBoxClick(data.url)}
        >
          <Box
            display="flex"
            width="100%"
            justifyContent="space-between"
            marginBottom="xs"
            alignItems="center"
          >
            <Typography variant="h6" weight="heavy" color="primary_1_700">
              {data.name}
            </Typography>
            <NonModalWithState data={data} isMobile />
          </Box>
          <EllipsisText
            variant="body-small"
            color="neutral_700"
            marginBottom="xs"
          >
            {data.description}
          </EllipsisText>
          <Box display="flex" marginBottom="md">
            <Box width="50%" display="flex" flexDirection="column">
              <Typography variant="body-small" color="neutral_700">
                Created
              </Typography>
              <Typography color="primary_1_700" weight="heavy">
                {formatDate(data.createdOn)}
              </Typography>
            </Box>
            <Box width="50%" display="flex" flexDirection="column">
              <Typography variant="body-small" color="neutral_700">
                Last modified
              </Typography>
              <Typography color="primary_1_700" weight="heavy">
                {formatDate(data.modifiedDate)}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider variant="dashed" colorOn="bg_white" />
        <Box
          paddingTop="xs"
          paddingLeft="md"
          paddingRight="md"
          paddingBottom="md"
        >
          <Box
            display="flex"
            width="100%"
            justifyContent="space-between"
            marginBottom="xs"
          >
            <Typography color="primary_1_700" weight="heavy">
              Stock Alerts
            </Typography>
            <SavedSearchesSwitch
              params={{
                id: data.id,
                searchName: data.name,
                url: data.url,
                notifyMe: data.notifyMe,
                deactivationDate: data.deactivationDate,
                deleteOnDeactivation: Boolean(data.deactivationDate),
              }}
              isToUseAuthZero={isToUseAuthZero}
            />
          </Box>
          {data.deactivationDate && (
            <Box width="50%" display="flex" flexDirection="column">
              <Typography variant="body-small" color="neutral_700">
                Alerts stop
              </Typography>
              <Typography color="primary_1_700" weight="heavy">
                {formatDate(data.deactivationDate)}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    ))}
  </Box>
);

export default SavedSearchesMobileView;
